import CloseIcon from "@mui/icons-material/Close";
import { TabContext } from "@mui/lab";
import {
  Badge,
  Box,
  Drawer,
  IconButton,
  Tab,
  tabsClasses,
  Typography,
} from "@mui/material";
import React, { Fragment, useEffect, useRef, useState } from "react";
import AlaramIco from "../../assets/icons/AlaramIco";
import QuickInProgressIco from "../../assets/icons/QuickInProgressIco";
import CommonButton from "../../component/Button";
import { HandleSkeletion } from "../../utils/constants";
import CommonAccordion from "../common-components/CommonAccordion";
import {
  CommonGrid2,
  DataFound,
  TabPanelView,
  TabViewSection,
} from "../common-components/StyledComponents";
import NotificationCard from "./notificationCard";
import {
  DeadlineNotification,
  NotificationCount,
  NotificationRemove,
  ProcessNotification,
  UnreadNotification,
} from "../../redux/action/notification";
import TickIco from "../../assets/icons/TickIco";
import { useLocation, useNavigate } from "react-router-dom";
import FailedIco from "../../assets/icons/FailedIco";
import { useDispatch } from "react-redux";
import { ShowSnackbar } from "../../redux/action/ShowSnackbar";
import { NoDataFound } from "../common-components/NotificationFunction";
import { CustomDiv } from "../chat-bot/style";

const SectionHeader = ({ title, count, margin }) => (
  <Box margin={margin || "16px 0px 8px"}>
    <Box display={"flex"} alignItems={"center"} gap={1}>
      <Typography variant="body4" fontWeight={700} color="#101828">
        {title}
      </Typography>
      {/* {typeof count === "number"  && (
        <Badge
          badgeContent={count}
           showZero
          color="primary"
          sx={{
            left: "0.8rem",
            "& .MuiBadge-badge": {
              backgroundColor: "#F79009",
            },
          }}
        />
      )} */}
    </Box>
  </Box>
);
const NotificationDrawer = ({ open, onClose, data }) => {
  const wrapRefs = useRef({
    today_notification: {},
    past_notification: {},
    deadline_notification: {},
  });
  // const removingKeys = useRef(new Set());
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const cardRefs = useRef({
    today_notification: {},
    past_notification: {},
    deadline_notification: {},
  });
  const [notification, setNotification] = useState({
    process_notification: [],
    deadline_notification: [],
    today_notification: [],
    past_notification: [],
    past_notification_count: 0,
    today_notification_count: 0,
    deadline_notification_count: 0,
    loading: true,
    condition_id: [],
  });

  const [showCompletedItems, setShowCompletedItems] = useState(false);
  const [activeTab, setActiveTab] = useState("Today");
  const tabData = ["Today", "This Week"];

  useEffect(() => {
    if (open || location) {
      fetchNotifications();
    }
  }, [location, open]);
   const formatTo12Hour = (date) => {
  if (!date) return "";

  return new Date(date).toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

  const fetchNotifications = async () => {
    try {
      setNotification((prev) => ({
        ...prev,
        loading: true,
      }));
      const process_data = await ProcessNotification();
      const deadline_data = await DeadlineNotification();
      const unread = await UnreadNotification();
      const process_notification = process_data.map((item) => {
        if (item.type === "match_group") {
          const completed = item.resume.filter(
            (r) => r.status === "completed"
          ).length;
          const total = item.resume.length;

          return {
            id: item.jobid,
            title: "Quick Match In Progress",
            job_title: item.job_title,
            resume: item.resume,
            meta: `${completed}/${total}`,
            percent: Math.round((completed / total) * 100),
            time: item.created_at
              ? formatTo12Hour(item.created_at)
              : "",
            icon: <QuickInProgressIco />,
          };
        }

        if (item.type === "job") {
          return {
            id: item.jobid,
            title: item.is_ignite
              ? "Sow Enrichment In Progress"
              : "Job Enrichment In Progress",
            metamessage: item.message,
            resume: item.file_name,
            percent: item.percent,
            time: formatTo12Hour(item.created_at),
            icon: <QuickInProgressIco />,
          };
        }

        if (item.type === "resume") {
          return {
            id: item.resume_id,
            title: "Resume enrichment In Progress",
            metamessage: item.message,
            resume: item.file_name,
            percent: item.percent,
            time: formatTo12Hour(item.created_at),
            icon: <QuickInProgressIco />,
          };
        }

        return null;
      });
      const deadline_notification = (deadline_data.notifications || []).map(
        (item, index) => {
          return {
            unique_id: item.unique_id,
            title: item.message,
            job_title: item.job_title,
            jobId: item.job_id,
            icon: <AlaramIco />,
            time: formatTo12Hour(item.created_at),
            action: "View",
          };
        }
      );
      const unread_notification = (data) => {
        return data.map((item) => {
          return {
            ...item,
            id: item.id,
            title: item.message,
            event_type: item.event_type,
            metadata: item.metadata,
            jobId: item.job_id,
            resume_id: item.resume_id,
            failed:
              item.event_type === "completion" &&
              item.metadata.status === "failed"
                ? true
                : false,
            icon:
              item.event_type === "automation" ? (
                <AlaramIco color={"#7F56D9"} />
              ) : item.event_type === "completion" &&
                item.metadata.status === "success" ? (
                <TickIco />
              ) : item.event_type === "completion" &&
                item.metadata.status === "failed" ? (
                <FailedIco />
              ) : item.event_type === "incoming_record" ? (
                <TickIco />
              ) : (
                <TickIco />
              ),
            time: formatTo12Hour(item.created_at),
            action: "View",
          };
        });
      };

      let pass_data = {
        process_notification: process_notification || [],
        deadline_notification: deadline_notification || [],
        deadline_notification_count: deadline_data.count ?? 0,
        today_notification: unread_notification(
          unread.today_notifications || []
        ),
        past_notification_count: unread.past_count ?? 0,
        today_notification_count: unread.today_count ?? 0,
        past_notification: unread_notification(unread.past_notifications || []),
      };
      setNotification((prev) => ({
        ...prev,
        ...pass_data,

        loading: false,
      }));
      dispatch(
        NotificationCount({
          data: {
            count:
              process_notification.length +
              deadline_notification.length +
              unread.past_count +
              unread.today_count,
            data: {
              ...pass_data,
            },
          },
        })
      );
    } catch (error) {
      dispatch(
        ShowSnackbar({
          open: true,
          message: error?.message,
          severity: "error",
        })
      );
    } finally {
      setNotification((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const handleChange = async (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleRemove = async (id, item, condition) => {
    // const key = `${condition}-${id}`;
    // if (removingKeys.current.has(key)) return;
    // removingKeys.current.add(key);

    // const wrap = wrapRefs.current[condition]?.[id];
    // const card = cardRefs.current[condition]?.[id];

    // if (!wrap || !card) {
    //   removingKeys.current.delete(key);
    //   return;
    // }

    // card.style.transition = "border-color 0.12s, background 0.12s";
    // card.style.borderColor = "#FF1744";
    // card.style.background = "#FFF0F0";

    let payload = {
      notification_id: item.id,
      //   notification_id:
      // condition === "deadline_notification"
      //   ? item.unique_id   // ✅ correct field
      //   : item.id,
    };
    NotificationRemove(payload);
    // setTimeout(() => {
    //   card.style.opacity = "0";
    //   card.style.pointerEvents = "none";

    //   const rect = card.getBoundingClientRect();
    //   const W = rect.width;
    //   const H = rect.height;

    //   spawnBubbles(wrap, W, H, 120, 0);
    //   spawnBubbles(wrap, W, H, 80, 1);
    //   spawnBubbles(wrap, W, H, 50, 2);

    //   setTimeout(() => {
    //     wrap.style.transition =
    //       "max-height 0.32s ease, opacity 0.25s ease, margin 0.32s ease";
    //     wrap.style.maxHeight = wrap.offsetHeight + "px";
    //     wrap.style.overflow = "hidden";

    //     requestAnimationFrame(() =>
    //       requestAnimationFrame(() => {
    //         wrap.style.maxHeight = "0px";
    //         wrap.style.opacity = "0";
    //         wrap.style.marginBottom = "0";
    //       })
    //     );

    //     setTimeout(() => {
    setNotification((prev) => {
      const countKey = `${condition}_count`;
      return {
        ...prev,
        [condition]: prev[condition].filter((i, _) => i.id !== item.id),
        [countKey]: (prev[countKey] || 0) - 1,
        condition_id: [...prev.condition_id, item.id || item.jobId],
      };
    });

    // delete wrapRefs.current[condition][id];
    // delete cardRefs.current[condition][id];

    // removingKeys.current.delete(key);
    //     }, 340);
    //   }, 680);
    // }, 130);
  };

  const renderNotificationContent = (data, count, label) => {
    const condition =
      label === "Today" ? "today_notification" : "past_notification";
    if (notification.loading) {
      return <HandleSkeletion height={80} />;
    }
    if (count === 0) {
      return <NoDataFound message="No Notification !" />;
    }
    return (
      <NotificationCard
        data={data}
        wrapRefs={wrapRefs.current[condition]}
        cardRefs={cardRefs.current[condition]}
        handleRemove={handleRemove}
        name_pass={condition}
        handleActionClick={handleActionClick}
        notification={notification}
      />
    );
  };

  const handleClose = () => {
    onClose();
  };

  const handleActionClick = (condition, item) => {
    handleClose();
    if (
      condition === "today_notification" ||
      condition === "past_notification"
    ) {
      let payload = {
        notification_id: item.id,
      };
      NotificationRemove(payload);
    }
    if (condition === "deadline_notification") {
      navigate(
        `/jobs/jobs-view?id=${item.jobId}&title=${item.job_title}&value=1`
      );
    } else if (item.event_type === "completion") {
      if (
        item.sub_type === "resume_parsing" && item.metadata.resume_status === "active"

      ) {
        navigate(`candidates/candidate-view?view-id=${item.resume_id}`);
      }
      else if (
        item.sub_type === "resume_parsing" && item.metadata.resume_status === "draft"

      ) {
        navigate(`/resume-intelligence/create-candidate-resume?resume=parse&resume_id=${item.resume_id}&status=draft`);
      }      
      else if(item.sub_type ===  "resume_rescore")
        {
          navigate(`/candidates/candidate-view?view-id=${item.resume_id}`);
        }
      
      
      else if (
        item.sub_type === "job_resume_rescore" ||
        item.sub_type === "match_complete"
      ) {
        if (item.metadata.jd_type === "SOW") {
          navigate(
            `/judica/judica-view?id=${item.metadata.job_id}&title=${item.metadata.job_title}&value=1`
          );
        } else {
          navigate(
            `/jobs/jobs-view?id=${item.metadata.job_id}&title=${item.metadata.job_title}&value=1`
          );
        }
      } else if (
        item.sub_type === "job_enrichment" ||
        item.sub_type === "job_rescore"
      ) {
        if (item.metadata.job_status === "Draft") {
          if (item.metadata.jd_type === "SOW") {
            navigate(
              `/sow-enrichment/create-enrich?id=${item.metadata.job_id}`
            );
          } else {
            navigate(
              `/jobs/new-job?id=${item.metadata.job_id}&title=${item.metadata.job_title}&value=0`
            );
          }
        } else if (item.metadata.job_status === "Active") {
          if (item.metadata.jd_type === "SOW") {
            navigate(
              `/judica/judica-view?id=${item.metadata.job_id}&title=${item.metadata.job_title}&value=1`
            );
          } else {
            navigate(
              `/jobs/jobs-view?id=${item.metadata.job_id}&title=${item.metadata.job_title}&value=1`
            );
          }
        } else {
          navigate(
            `/jobs/jobs-view?id=${item.metadata.job_id}&title=${item.metadata.job_title}&value=1`
          );
        }
      } else if (
        item.sub_type === "match_complete" ||
        item.sub_type === "resume_matching"
      ) {
        navigate(
          `/jobs/jobs-view?id=${item.metadata.job_id}&title=${item.metadata.job_title}&value=1`
        );
      }
    } else if (item.event_type === "automation") {
      navigate("/job-krystal-path");
    } else if (item.event_type === "incoming_record") {
      if (item.sub_type === "resume_upload") {
        navigate(
          `/jobs/jobs-view?id=${item.metadata.job_id}&title=${item.metadata.job_title}&value=1`
        );
      } else if (item.sub_type === "candidate_availability_update") {
        navigate(`/candidates/candidate-view?view-id=${item.resume_id}`);
      } else if (item.sub_type === "coversheet_submitted") {
          if(item.metadata.resume_order_no === 1 || item.metadata.resume_order_no === 2 || item.metadata.resume_order_no === 3){
            const value = item.metadata.resume_order_no === 1 ? 2 : item.metadata.resume_order_no === 2 ? 3 : 4;
            navigate(
                `/jobs/jobs-view?id=${item.job_id}&title=${item.metadata.job_title}&value=${value}&match-id=${item.metadata.match_resume_id}`
            );
            
          }
          else{
            navigate(
              `/jobs/jobs-view?id=${item.job_id}&title=${item.metadata.job_title}&value=0`
            );
          }
      }
    }
  };

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={handleClose}
      ModalProps={{ keepMounted: true }}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 2,
      }}
      PaperProps={{
        sx: {
          width: 360,
          maxWidth: "90vw",
          backgroundColor: "#F9FAFB",
          boxShadow:
            "0px 12px 30px rgba(15, 23, 42, 0.35), 0px 0px 0px 1px rgba(15, 23, 42, 0.06)",
        },
      }}
    >
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        backgroundColor={"#F9FAFB"}
        padding={"1rem 0.5rem 1rem 1rem"}
      >
        <Typography variant="h3" fontWeight={700} color="#101828">
          Activity Center
        </Typography>

        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box
        padding={"1rem"}
        height={"100%"}
        sx={{
          overflowY: "auto",
          overflowX: "hidden",
        }}
        backgroundColor="#FFF"
      >
        <SectionHeader title="In progress" margin="0px 0px 8px" />
        {notification.loading ? (
          <HandleSkeletion height={80} />
        ) : (
          <Fragment>
            {notification.process_notification.length === 0 ? (
              <DataFound padding="10px" margin="auto">
                <CustomDiv fontSize="20px">👋</CustomDiv>
                {"No ongoing tasks at the moment."}
              </DataFound>
            ) : (
              <>
                <NotificationCard
                  data={
                    showCompletedItems
                      ? notification.process_notification
                      : notification.process_notification.slice(0, 1)
                  }
                  buffer_shown={true}
                  isInProgress={true}
                  name_pass={"process_notification"}
                  notification={notification}
                  removeIcon={false}
                />

                {notification.process_notification.length > 1 && (
                  <CommonGrid2
                    sx={{ mt: 1 }}
                    display={"flex"}
                    justifyContent={"flex-end"}
                  >
                    <CommonButton
                      value={
                        showCompletedItems
                          ? "Show Less"
                          : `Show More (${
                              notification.process_notification.length - 1
                            })`
                      }
                      variant="text"
                      color="#6941C6"
                      fontSize={"13px"}
                      background={"transparent"}
                      fontWeight={700}
                      padding={"8px 5px"}
                      borderRadius={"5px"}
                      onClick={() => setShowCompletedItems(!showCompletedItems)}
                      customStyle={{
                        border: "none",
                        "&:hover": {
                          background: "rgba(107, 65, 198, 0.1)",
                        },
                      }}
                    />
                  </CommonGrid2>
                )}
              </>
            )}
          </Fragment>
        )}

        <CommonAccordion
          title={
            <CommonGrid2 display={"flex"} gap={"1.2rem"} alignItems={"center"}>
              Submission Deadlines
              <Badge
                badgeContent={notification.deadline_notification_count}
                showZero
                color="primary"
                sx={{
                  "& .MuiBadge-badge": {
                    backgroundColor: "#F79009",
                  },
                }}
              />
            </CommonGrid2>
          }
          variant="body4"
          defaultOpen={false}
          wholeborder="0px"
          customStyle={{
            backgroundColor: "transparent",
            "& .MuiAccordionSummary-root": {
              padding: "0px",
              backgroundColor: "transparent",
            },
            "& .MuiAccordion-heading": {
              h4: {
                fontWeight: 700,
              },
            },
            "& .Mui-expanded": {
              padding: "0px",
              minHeight: "auto !important",
            },
            "& .MuiCollapse-root": {
              padding: "0px",
            },
            "& .MuiCollapse-wrapper": {
              padding: "0px",
            },
            marginTop:
              notification.process_notification.length !== 0 ? "0px" : "1rem",
          }}
          children={
            <Fragment>
              {notification.loading ? (
                <HandleSkeletion height={80} />
              ) : notification.deadline_notification.length === 0 ? (
                <DataFound padding="10px" margin="auto">
                  <CustomDiv fontSize="20px">👋</CustomDiv>
                  {"No current deadline"}
                </DataFound>
              ) : (
                <NotificationCard
                  data={notification.deadline_notification || []}
                  wrapRefs={wrapRefs.current["deadline_notification"]}
                  cardRefs={cardRefs.current["deadline_notification"]}
                  handleRemove={handleRemove}
                  name_pass={"deadline_notification"}
                  handleActionClick={handleActionClick}
                  notification={notification}
                  removeIcon={false}
                />
              )}
            </Fragment>
          }
        />

        <SectionHeader
          title="Notifications"
          margin="1.5rem  0px 8px"
          // count={
          //   notification.today_notification_count +
          //   notification.past_notification_count
          // }
        />
        <TabContext value={activeTab}>
          <TabViewSection
            color="#00144A"
            padding="0px 16px"
            fontWeight={700}
            minHeight="35px"
            borderRadius="8px"
            boxShadow="0px 0px 8.7px 0px #10182833"
            onChange={handleChange}
            sx={{
              margin: "10px 0px 1rem",
              minWidth: "-webkit-fill-available",
              [`& .${tabsClasses.scrollButtons}`]: {
                "&.Mui-disabled": { opacity: 0.3 },
              },
              "& .MuiButtonBase-root": {
                flex: 1,
              },
            }}
          >
            {tabData.map((item, index) => (
              <Tab
                key={item}
                label={
                  <CommonGrid2 display={"flex"} alignItems={"center"}>
                    {item === activeTab ? (
                      <Fragment>
                        <span>{item}</span>
                        {/* <Badge
                          badgeContent={
                            item === "Today"
                              ? notification.today_notification_count ?? 0
                              : notification.past_notification_count ?? 0
                          }      
                          showZero            
                          sx={{
                            left: "1rem",
                            "& .MuiBadge-badge": {
                              backgroundColor: "#F79009",
                              color: "#fff",
                            },
                          }}
                        /> */}
                      </Fragment>
                    ) : (
                      item
                    )}
                  </CommonGrid2>
                }
                value={item}
                disabled={notification.loading}
              />
            ))}
          </TabViewSection>
          <TabPanelView value="Today" padding="0px">
            {renderNotificationContent(
              notification.today_notification,
              notification.today_notification_count,
              "Today"
            )}
          </TabPanelView>

          <TabPanelView value="This Week" padding="0px">
            {renderNotificationContent(
              notification.past_notification,
              notification.past_notification_count,
              "This Week"
            )}
          </TabPanelView>
        </TabContext>
      </Box>
    </Drawer>
  );
};

export default NotificationDrawer;
